<template>
  <div>
    <my-sessions-desktop v-if="screenType === 'desktop'"></my-sessions-desktop>
    <my-sessions-mobile v-else></my-sessions-mobile>
  </div>
</template>

<script>

import MySessionsDesktop from "@/components/Pages/Desktop/Dashboard/Sessions/MySessionsDesktop.vue";
import MySessionsMobile from "@/components/Pages/Mobile/Dashboard/Sessions/MySessionsMobile.vue";

export default {
  name: "SessionMain",
  components: {MySessionsMobile, MySessionsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>